import { RequestService } from "services/request.service";

export class RetrieveGroupApi extends RequestService {
	public retrieveGroupsApi = async () => {
		const result = await this.request("group/retrieve", "GET", {});
		return result;
	};
}
